import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { fileBrowserInitialState, fileBrowserReducer, } from "../report/fileBrowser/store";
import { initialState as behaviorInitialState, behaviorReducer, } from "./behaviorSlice";
import { initialState as cbomInitialState, cbomReducer } from "./cbomSlice";
import { initialState as filesDiffInitialState, filesDiffReducer, } from "./filesDiffSlice";
import { initialState as issuesDiffInitialState, issuesDiffReducer, } from "./issuesDiffSlice";
import { initialState as issuesInitialState, issuesReducer, } from "./issuesSlice";
import { initialState as licensesInitialState, licensesReducer, } from "./licensesSlice";
import { initialState as malwareInitialState, malwareReducer, } from "./malwareSlice";
import { initialState as mlbomInitialState, mlbomReducer } from "./mlbomSlice";
import { initialState as networkingInitialState, networkingReducer, } from "./networkingSlice";
import { initialState as policiesInitialState, policiesReducer, } from "./policiesSlice";
import { initialState as saasbomInitialState, saasbomReducer, } from "./saasbomSlice";
import { initialState as sbomInitialState, sbomSliceReducer, } from "./sbomSlice";
import { initialState as reportInitialState, reportReducer, } from "./sdlcReportSlice";
import { initialState as secretsInitialState, secretsReducer, } from "./secretsSlice";
import { initialState as signaturesInitialState, signaturesReducer, } from "./signaturesSlice";
import { initialState as vulnerabilitiesInitialState, vulnerabilityReducer, } from "./vulnerabilitySlice";
export const allReportReducers = {
    behavior: behaviorReducer,
    cbom: cbomReducer,
    fileBrowser: fileBrowserReducer,
    filesDiff: filesDiffReducer,
    issues: issuesReducer,
    licenses: licensesReducer,
    issuesDiff: issuesDiffReducer,
    malware: malwareReducer,
    mlbom: mlbomReducer,
    networking: networkingReducer,
    policies: policiesReducer,
    saasbom: saasbomReducer,
    sbom: sbomSliceReducer,
    sdlcReport: reportReducer,
    secrets: secretsReducer,
    signatures: signaturesReducer,
    vulnerabilities: vulnerabilityReducer,
};
export const initialState = {
    behavior: behaviorInitialState,
    cbom: cbomInitialState,
    fileBrowser: fileBrowserInitialState,
    filesDiff: filesDiffInitialState,
    issues: issuesInitialState,
    licenses: licensesInitialState,
    malware: malwareInitialState,
    issuesDiff: issuesDiffInitialState,
    mlbom: mlbomInitialState,
    networking: networkingInitialState,
    policies: policiesInitialState,
    saasbom: saasbomInitialState,
    sbom: sbomInitialState,
    sdlcReport: reportInitialState,
    secrets: secretsInitialState,
    signatures: signaturesInitialState,
    vulnerabilities: vulnerabilitiesInitialState,
};
const tmpReportReducer = combineReducers({
    report: combineReducers(allReportReducers),
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const tmpReportStore = configureStore({
    reducer: tmpReportReducer,
});
export { reportCleared, scrollTo } from "./sdlcReportSlice";
//# sourceMappingURL=index.js.map